import TextField from '@material-ui/core/TextField'
import React from 'react'
import { controlHasError } from '../../lib/errorHandler'
import ExpandablePanel from '../controls/ExpandablePanel'
import ZasadyRachunkowosciStyle from '../../styles/ZasadyRachunkowosciStyle'
import PrintText from '../../lib/PrintText'

function OpisKryteriowWylaczen({
  data,
  errors,
  onSetSectionData,
  czyPodsumowanie,
}) {
  return (
    <ZasadyRachunkowosciStyle>
      <ExpandablePanel title="STOSOWANE KRYTERIA WYŁĄCZEŃ JEDNOSTEK PODPORZĄDKOWANYCH ZE SKONSOLIDOWANEGO SPRAWOZDANIA FINANSOWEGO">
        <form autoComplete="off" className="subsection">
          {czyPodsumowanie ? (
            <PrintText
              text={data.OpisKryteriowWylaczen}
            />
          ) : (
            <TextField
              className="textarea"
              error={controlHasError(errors, 'OpisKryteriowWylaczen')}
              name="OpisKryteriowWylaczen"
              label="Opis kryteriów"
              multiline
              variant="outlined"
              title={data.OpisKryteriowWylaczen}
              defaultValue={data.OpisKryteriowWylaczen}
              onBlur={(e) =>
                onSetSectionData('OpisKryteriowWylaczen', e.target.value)
              }
            />
          )}
        </form>
      </ExpandablePanel>
    </ZasadyRachunkowosciStyle>
  )
}

export default OpisKryteriowWylaczen
